import { useMemo, useState } from "react";

interface UsePostsPaginationProps {
  totalItems: number;
  itemsPerPage?: number;
}

export interface UsePostsPaginationReturn {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalPages: number;
  startIndex: number;
  endIndex: number;
  handlePageChange: (page: number) => void;
}

export function usePostsPagination({
  totalItems,
  itemsPerPage = 10,
}: UsePostsPaginationProps): UsePostsPaginationReturn {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = useMemo(() => {
    return Math.ceil(totalItems / itemsPerPage);
  }, [totalItems, itemsPerPage]);

  const startIndex = useMemo(() => {
    return (currentPage - 1) * itemsPerPage;
  }, [currentPage, itemsPerPage]);

  const endIndex = useMemo(() => {
    return startIndex + itemsPerPage;
  }, [startIndex, itemsPerPage]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    // Scroll suave para o topo
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return {
    currentPage,
    setCurrentPage,
    totalPages,
    startIndex,
    endIndex,
    handlePageChange,
  };
}
